import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "p-4 space-y-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 text-left border-b-2 border-green-show" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "住所管理")
], -1)
const _hoisted_4 = { class: "pb-12 space-y-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "bg-white py-2 px-4 rounded shadow" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-sm font-bold pb-2" }
const _hoisted_10 = { class: "text-sm" }
const _hoisted_11 = { class: "text-xs" }
const _hoisted_12 = { class: "fixed bottom-8 w-full px-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "table" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "table-cell align-middle text-white text-sm font-bold" }, " 住所を追加する ")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "space-y-8" }
const _hoisted_17 = { class: "space-x-2" }
const _hoisted_18 = { class: "text-left" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 氏名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_20 = { class: "space-x-2" }
const _hoisted_21 = { class: "text-left" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 郵便番号 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_23 = { class: "flex space-x-2" }
const _hoisted_24 = { class: "space-x-2 flex-1" }
const _hoisted_25 = { class: "text-left" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 都道府県 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "space-x-2 flex-1" }
const _hoisted_29 = { class: "text-left" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 市区町村 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_31 = { class: "space-x-2" }
const _hoisted_32 = { class: "text-left" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 丁目・番地 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_34 = { class: "space-x-2" }
const _hoisted_35 = { class: "text-left" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, "建物名", -1)
const _hoisted_37 = { class: "space-x-2" }
const _hoisted_38 = { class: "text-left" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 電話番号 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-500 ml-2" }, " 必須 ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-green-show w-full rounded-md py-3"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center text-sm font-bold" }, "保存")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.userAddresses.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_van_empty, { description: "登録している住所がありません" })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAddresses, (userAddress) => {
          return (_openBlock(), _createElementBlock("div", {
            key: userAddress.addressId
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "text-left flex space-x-2 grow",
                  onClick: ($event: any) => (
                  userAddress.isDefault
                    ? ''
                    : _ctx.setIsDefault(userAddress.addressId!)
                )
                }, [
                  _createVNode(_component_CheckIcon, {
                    class: _normalizeClass(["w-6 h-6 my-auto text-green-lightShow", userAddress.isDefault ? '' : 'invisible'])
                  }, null, 8, ["class"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(userAddress.name), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(userAddress.zipCode), 1),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(userAddress.cityName) + _toDisplayString(userAddress.streetName) + _toDisplayString(userAddress.buildingName), 1)
                  ])
                ], 8, _hoisted_8),
                (!userAddress.isDefault)
                  ? (_openBlock(), _createBlock(_component_XMarkIcon, {
                      key: 0,
                      class: "h-6 w-6 my-auto",
                      onClick: ($event: any) => (_ctx.deleteAddress(userAddress.addressId!))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", {
        class: "flex justify-center bg-green-show py-3 px-4 rounded space-x-2 m-auto relative",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAddAddressPopup && _ctx.openAddAddressPopup(...args)))
      }, _hoisted_14)
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showAddAddressPopup,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showAddAddressPopup) = $event)),
      position: "bottom",
      style: {height: '90%'},
      closeable: true,
      round: true,
      class: "bg-gray-lightShow py-12 px-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_Form, { onSubmit: _ctx.saveUserAddress }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.address.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.address.name) = $event)),
                        name: "lastName",
                        type: "text",
                        class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                        placeholder: "山田",
                        rules: "required"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "text-red-500 text-xs",
                        name: "lastName"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.address.zipCode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address.zipCode) = $event)),
                        name: "zipCode",
                        type: "number",
                        class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                        placeholder: "1730004",
                        rules: "required"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "text-red-500 text-xs",
                        name: "zipCode"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.address.prefectureId,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.prefectureId) = $event)),
                          name: "prefecture",
                          as: "select",
                          rules: "requiredNullable",
                          class: "mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-green-show focus:outline-none focus:ring-green-show sm:text-sm"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefectures, (prefecture) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: prefecture.prefectureId,
                                value: prefecture.prefectureId
                              }, _toDisplayString(prefecture.name), 9, _hoisted_27))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "text-red-500",
                          name: "prefecture"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.address.cityName,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address.cityName) = $event)),
                          name: "cityName",
                          type: "text",
                          class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                          placeholder: "新宿区",
                          rules: "required"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "text-red-500 text-xs",
                          name: "cityName"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.address.streetName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.address.streetName) = $event)),
                        name: "streetName",
                        type: "text",
                        class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                        placeholder: "新宿〇丁目〇番地〇号",
                        rules: "required"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "text-red-500 text-xs",
                        name: "streetName"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.address.buildingName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address.buildingName) = $event)),
                        name: "buildingName",
                        type: "text",
                        class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                        placeholder: "○○ビル102",
                        rules: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "text-red-500 text-xs",
                        name: "buildingName"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.address.phoneNumber,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.address.phoneNumber) = $event)),
                        name: "phoneNumber",
                        type: "number",
                        class: "block w-full border-0 border-b border-green-lightShow bg-transparent focus:ring-transparent placeholder:text-gray-placeholder",
                        placeholder: "08012345678",
                        rules: "required"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "text-red-500 text-xs",
                        name: "phoneNumber"
                      })
                    ])
                  ]),
                  _hoisted_40
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}